<template>
  <section id="act--create-main">

    <div class="act--create-header">
      <p>Create New Authentication Instance</p>
      <v-select
        :items="selectAuthItems"
        v-model="selectAuth"
        label="Select Authentication Instance Type"
        single-line
        item-text="text"
        item-value="value"
        class="act--create-header-select" />
    </div>
    <div v-if="selectAuth === 'resource'">
      <create-resource/>
    </div>

    <div v-if="selectAuth === 'action'">
      <create-action/>
    </div>


    <div v-if="selectAuth === 'role'">
      <create-role/>
    </div>
  </section>
</template>
<script>
import CreateResource from "./components/createResource.vue";
import CreateAction from "./components/createAction.vue";
import CreateRole from "./components/createRole.vue";
export default {
  data() {
    return {
      selectAuth: { text: "", value: "" },
      selectAuthItems: [
        { text: "New Resource", value: "resource" },
        { text: "New Action", value: "action" },
        { text: "New Role", value: "role" }
      ]
    };
  },
  components: {
    CreateResource,
    CreateAction,
    CreateRole
  }
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/Activities_create.styl';
</style>

